import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import {
    BASE_URL, getDefaultHeaders, getDynamicHeaders, Entity,
} from '../config';
import {
    IUser, IUserUUID, IResult, ILike, IPagination,
    ICriteria, IFoundByCriteria, ILikedUser, ISetCriteria,
} from './types';

export const usersAPI = createApi({
    reducerPath: 'users',
    baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
    tagTypes: ['Filters'],
    endpoints: (build) => ({
        getFeed: build.query<IUser[], IPagination>({
            query: (payload) => ({
                url: `${Entity.profiles}?limit=${payload.limit}&offset=${payload.offset}`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getUser: build.query<IUser, IUserUUID>({
            query: (payload) => ({
                url: `${Entity.profiles}/${payload.uuid}`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getFilters: build.query<ICriteria, void>({
            query: () => ({
                url: `${Entity.profiles}/criteria-list`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
            providesTags: () => ['Filters'],
        }),
        getLikedByMe: build.query<ILikedUser[], IPagination>({
            query: (payload) => ({
                url: `${Entity.likes}/from-me?limit=${payload.limit}&offset=${payload.offset}`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getLikedByUser: build.query<ILikedUser[], IPagination>({
            query: (payload) => ({
                url: `${Entity.likes}/to-me?limit=${payload.limit}&offset=${payload.offset}`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        postReaction: build.mutation<IResult, ILike>({
            query: (payload) => ({
                url: `${Entity.likes}/profile/${payload.uuid}`,
                method: 'PUT',
                body: { add: payload.add },
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getBlockedUsers: build.query<IUser[], IPagination>({
            query: (payload) => ({
                url: `${Entity.profiles}/blocklist?limit=${payload.limit}&offset=${payload.offset}`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
            keepUnusedDataFor: 1,
        }),
        postBlock: build.mutation<IResult, IUserUUID>({
            query: (payload) => ({
                url: `${Entity.profiles}/${payload.uuid}/blocklist`,
                method: 'POST',
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        deleteBlock: build.mutation<IResult, IUserUUID>({
            query: (payload) => ({
                url: `${Entity.profiles}/${payload.uuid}/blocklist`,
                method: 'DELETE',
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        postFilters: build.mutation<IFoundByCriteria, ISetCriteria | []>({
            query: (payload) => ({
                url: `${Entity.profiles}/criteria-list`,
                method: 'PUT',
                body: payload,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
            invalidatesTags: () => ['Filters'],
        }),
    }),
});
